// import { PictureUrl } from "common/api";

import { dynamicConfig } from "./dynamicConfigs";

export const { cdnUrl } = dynamicConfig;

export const DEFAULT_VIDEO_CONSTRAINTS: MediaStreamConstraints["video"] = {
  width: 1280,
  height: 720,
  frameRate: 24,
};

// These are used to store the selected media devices in localStorage.
export const SELECTED_AUDIO_INPUT_KEY = "selectedAudioInput";
export const SELECTED_AUDIO_OUTPUT_KEY = "selectedAudioOutput";
export const SELECTED_VIDEO_INPUT_KEY = "selectedVideoInput";
export const audio = "audio";
export const video = "video";

export const threeUsers = 2;

export const MIN_AGE = 60;

export const aloneTimeout = 60;

export const FdModel = `${cdnUrl}resources/models`;

export const APP_NAME = "PastimeLive";
export const AGORA = "AGORA";
export const TWILIO = "TWILIO";
export const channelTypes = [AGORA, TWILIO] as const;

export const NotificationsSwitchers = [
  "notifyStarredOnline",
  "inviteMeToRoom",
  "emailMeFriendJoindPatime",
  "notifyKnownOnline",
  "updateds",
  "autoStarUsers",
];
